<template lang="pug">
section
  s-page-title(title='Организации')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название') {{ props.item.name }}
          td(data-label='Сфера деятельности') {{ orgSphereName(props.item.sphere_id) }}
          td(data-label='Кол-во акций') {{ props.item.actions_count }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%'
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '60%'
      },
      {
        text: 'Сфера деятельности',
        align: 'left',
        value: 'sphere_id',
        width: '20%',
        sortable: false
      },
      {
        text: 'Кол-во акций',
        align: 'left',
        value: 'actions_count',
        width: '20%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetchOrgSpheresDict()
  },

  methods: {
    async onDelete(id) {
      if (!this.isLoading && (await this.$confirm('Удалить организацию?'))) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления организации')
        }

        this.fetch()
      }
    },

    orgSphereName(id) {
      let sphere = this.orgSphereById(id)
      return sphere ? sphere.name : null
    },

    onEdit(id) {
      this.$router.push({
        name: 'Partners.Organizations.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('partners/organizations', ['fetchList', 'destroy']),
    ...mapActions('dictionary/orgSpheres', { fetchOrgSpheresDict: 'fetch' }),
    ...mapMutations('partners/organizations', ['setDataFilter'])
  },

  computed: {
    ...mapState('partners/organizations', ['total', 'dataFilter']),
    ...mapGetters('partners/organizations', ['list', 'isLoading']),
    ...mapGetters('dictionary/orgSpheres', { orgSphereById: 'byId' })
  }
}
</script>
